module.exports = __webpack_public_path__ + "img/VeinteMIl.fda153b9.jpg";